import {
  ApplicationConfig,
  ErrorHandler,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from "@angular/core";
import {
  provideRouter,
  Router,
  withComponentInputBinding,
  withPreloading,
  PreloadAllModules,
} from "@angular/router";
import {
  ModalController,
  provideIonicAngular,
  AnimationBuilder,
} from "@ionic/angular/standalone";
import { iosTransitionAnimation } from "@ionic/angular";
import { routes } from "./app.routes";
import { providePrimeNG } from "primeng/config";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import Aura from "@primeuix/themes/aura";
import { provideHttpClient } from "@angular/common/http";
import { provideAngularSvgIcon } from "angular-svg-icon";
import { APP_INITIALIZER } from "@angular/core";
import * as Sentry from "@sentry/angular";
import { ConfirmationService, MessageService } from "primeng/api";

export function fastNavAnimation(): AnimationBuilder {
  return (baseEl, opts) => {
    // call it and then override durations
    const animation = iosTransitionAnimation(baseEl, opts);

    // Ionic animations have a common API:
    animation.duration(150); // default ~280ms iOS / 200ms MD → reduce to 150ms
    animation.easing("cubic-bezier(0.36, 0.66, 0.04, 1)");
    return animation;
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    ModalController,
    MessageService,
    ConfirmationService,
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideHttpClient(),
    provideAngularSvgIcon(),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    provideRouter(routes, withComponentInputBinding(), withPreloading(PreloadAllModules)),
    provideIonicAngular({
      animated: true,
      mode: "ios",
      swipeBackEnabled: true,
      inputBlurring: true,
      navAnimation: fastNavAnimation(),
    }),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
};
